module.exports = __webpack_public_path__ + "media/src/images/icons/flags/sweden-c0f438e4800bb72f667b4459a880fd15.svg";